import cn from 'classnames'
import { tr } from 'mmfintech-commons'

import { MethodImage } from './MethodImage'
import { MethodButtonChecked, MethodButtonStyled } from './MethodButton.styled'

import checkedIcon from '../../../assets/icons/checked.svg'

type MethodButtonProps = {
  name: string
  selected: boolean
  setSelected: (name: string) => void
}

export const MethodButton = ({ name, selected, setSelected }: MethodButtonProps) => (
  <MethodButtonStyled className={cn({ selected })} onClick={() => setSelected(name)} data-test='button-payment-method'>
    <MethodImage method={name} className={cn({ selected })}>
      {selected && (
        <MethodButtonChecked>
          <img src={checkedIcon} alt='' />
        </MethodButtonChecked>
      )}
    </MethodImage>
    {tr('METADATA.PAYMENT_OPTIONS.' + name, name)}
  </MethodButtonStyled>
)
